// extracted by css-extract-rspack-plugin
export default {"formBody":"R10Report__formBody--z9acE","indentField":"R10Report__indentField--z8JHM","indent":"R10Report__indent--xPhzQ","indentBottom":"R10Report__indentBottom--z7mfH"};